import { ReactNode, useState } from 'react';
import Box from '@mui/material/Box';

type CoBrandedLogoProps = {
  // The Marco logo. Rendered on its own when there is no partner logo.
  children: ReactNode;
  partnerLogoUrl?: string | null;
  partnerName?: string | null;
};

// The row wraps so the same component fits both the full-width TopBar and the
// 240px activation sidebar.
export default function CoBrandedLogo({ children, partnerLogoUrl, partnerName }: CoBrandedLogoProps) {
  // The URL that failed rather than a flag, so a different logo gets its own chance.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  if (!partnerLogoUrl || failedUrl === partnerLogoUrl) return <>{children}</>;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '8px',
      }}
    >
      {children}
      <Box component="span" sx={{ fontSize: '20px', lineHeight: 1 }} aria-hidden>
        🤝
      </Box>
      <Box
        component="img"
        src={partnerLogoUrl}
        alt={partnerName || ''}
        onError={() => setFailedUrl(partnerLogoUrl)}
        sx={{ maxHeight: '35px', maxWidth: '132px', objectFit: 'contain' }}
      />
    </Box>
  );
}
